import React, { useState } from "react";
import {
  Button,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import SearchBar from "../../components/SearchBar";
import SwitchToggle from "../../components/SwitchToggle";
import AddFeatureGroup from "../../Modals/addFeatureGroup";
import { Group } from "../../types/types";

const ManageFeatures: React.FC = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [category, setCategory] = React.useState('default');
  const handleCategoryChange = (event: SelectChangeEvent) => {
    setCategory(event.target.value as string);
  };
  const [groupType, setGroupType] = React.useState('default');
  const handleGroupTypeChange = (event: SelectChangeEvent) => {
    setGroupType(event.target.value as string);
  };
  const [openModal, setOpenModal] = useState<boolean>(false);

  const [groups, setGroups] = useState<Group[]>([
    { id: 1, name: "Security", categories: ["Car"], status: true, groupType: "Interior", fieldType: "Checkbox" },
    { id: 2, name: "Cruise control", categories: ["Car", "Bike"], status: true, groupType: "Exterior", fieldType: "Checkbox" },
    { id: 3, name: "Air conditioning", categories: ["Car"], status: true, groupType: "Interior", fieldType: "Checkbox" },
    { id: 4, name: "Parking assistance", categories: ["Car", "Bike"], status: true, groupType: "Interior", fieldType: "Checkbox" },
    { id: 5, name: "Interior", categories: ["Car"], status: true, groupType: "Interior", fieldType: "Checkbox" },
    { id: 6, name: "Additional comfort features", categories: ["Car", "Bike"], status: true, groupType: "Interior", fieldType: "Checkbox" },
    { id: 7, name: "Infotainment", categories: ["Car"], status: true, groupType: "Exterior", fieldType: "Checkbox" },
    { id: 8, name: "Extras", categories: ["Car", "Bike"], status: true, groupType: "Exterior", fieldType: "Checkbox" },
  ]);

  return (
    <>
      <div className="main_title">
        <h1>Manage Features</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Features
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search Groups..."
            />
            <div className="form">
              <div className="control_group">
                <Select
                  fullWidth
                  value={category}
                  onChange={handleCategoryChange}
                >
                  <MenuItem disabled value="default">Select Category</MenuItem>
                  <MenuItem value="Car">Car</MenuItem>
                  <MenuItem value="Bike">Bike</MenuItem>
                  <MenuItem value="Bicycle">Bicycle</MenuItem>
                  <MenuItem value="Caravan">Caravan</MenuItem>
                  <MenuItem value="Trucks">Trucks</MenuItem>
                  <MenuItem value="Heavy Equipment">Heavy Equipment</MenuItem>
                  <MenuItem value="Spare Parts">Spare Parts</MenuItem>
                  <MenuItem value="Car Accessories">Car Accessories</MenuItem>
                </Select>
              </div>
              <div className="control_group">
                <Select
                  fullWidth
                  value={groupType}
                  onChange={handleGroupTypeChange}
                >
                  <MenuItem disabled value="default">Group Type</MenuItem>
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Interior">Interior</MenuItem>
                  <MenuItem value="Exterior">Exterior</MenuItem>
                </Select>
              </div>
            </div>
          </div>

          <div className="right_s">
            <Button className="btn btn_primary" onClick={() => setOpenModal(true)}>
              <AddIcon /> Add Feature Group
            </Button>
          </div>
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No.</TableCell>
                <TableCell>Feature Group Name</TableCell>
                <TableCell>Group Type</TableCell>
                <TableCell>Field Type</TableCell>
                <TableCell>Categories</TableCell>
                <TableCell>Enable/Disable</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {groups.map((row, index) => (
                <TableRow hover key={row.id}>
                  <TableCell>{index + 1}</TableCell>

                  <TableCell>
                    <div className="user_block click_action" onClick={() => navigate(`/manage-features/${row.id}`)}>
                      <p><b>{row.name}</b></p>
                    </div>
                  </TableCell>

                  <TableCell>{row.groupType}</TableCell>

                  <TableCell>{row.fieldType}</TableCell>

                  <TableCell>{row.categories.join(", ")}</TableCell>

                  <TableCell>
                    <SwitchToggle defaultChecked={row.status} />
                  </TableCell>

                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton onClick={() => navigate(`/manage-features/${row.id}`)}>
                        <img src="/static/images/eye_icon.svg" alt="Edit" />
                      </IconButton>
                      <IconButton onClick={() => setOpenModal(true)}>
                        <img src="/static/images/edit2_icon.svg" alt="Edit" />
                      </IconButton>
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      <AddFeatureGroup open={openModal} setOpen={setOpenModal} />
    </>
  );
};

export default ManageFeatures;